import { render, staticRenderFns } from "./CargaStockConfirmado.vue?vue&type=template&id=edcbd2cc&"
import script from "./CargaStockConfirmado.vue?vue&type=script&lang=js&"
export * from "./CargaStockConfirmado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports